module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-timber-kimberly-0.09fe070e.jpg";